import { render, staticRenderFns } from "./autoForm.vue?vue&type=template&id=12d747da&"
import script from "./autoForm.vue?vue&type=script&lang=js&"
export * from "./autoForm.vue?vue&type=script&lang=js&"
import style0 from "./autoForm.vue?vue&type=style&index=0&id=12d747da&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports